module.exports = {"data":{"site":{"siteMetadata":{"languages":{"defaultLangKey":"en","langs":["en","ru"]}}}},"pathContext":{"slug":"/","langKey":"en"}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/index.json
// module id = 889
// module chunks = 142629428675168